/* global G */
import settings from '@tenant/settings'
import decode from 'app/xEcoApm/helper/decode'
import encode from 'app/xEcoApm/helper/encode'

const { bluetooth }: { bluetooth: any } = settings

const {
  STATUS,
  FILE_TYPE,
  MAXIMUM_FILE_BLOCKS,
  EXPECTED_FILE_BLOCKS,
  MEAS_DURATION,
  ...bluetoothCommands
} = bluetooth?.commands || {}

type GET_FILE_PARAMS = {
  type: number,
  block: number,
}

type INIT_LIC_PARAMS = {
  date: string,
}

export type UPD_LIC_PARAMS = {
  serial: string,
  date?: string,
  durationMonths: number,
  licenseCounter: number,
  signature: string,
}

/**
 * Command helper.
 *
 * Eases the communication with the bluetooth adapter by creating an object that complies with its
 * expected input. Prefilled with the tenant's APM commands and data.
 *
 * @param payload
 */
const command = (payload: object) => Object.freeze({
  detail: {
    [G.DATA]: Object.freeze({
      service: bluetooth?.constants.apm.service,
      characteristics: bluetooth?.constants.apm.characteristics,
      payload,
      timeout: 10000,
    }),
    [G.FN]: Object.freeze({
      encode,
      decode,
    })
  }
})

const MEAS_CTRL_ON = command(bluetoothCommands.MEAS_CTRL_ON)
const MEAS_CTRL_OFF = command(bluetoothCommands.MEAS_CTRL_OFF)
const MEAS_RES = command(bluetoothCommands.MEAS_RES)
const GET_INFO = command(bluetoothCommands.GET_INFO)
const GET_STAT = command(bluetoothCommands.GET_STAT)

const GET_FILE = (params: GET_FILE_PARAMS) => command(bluetoothCommands.GET_FILE(params))
const INIT_LIC = (params: INIT_LIC_PARAMS) => command(bluetoothCommands.INIT_LIC(params))
const UPD_LIC = (params: UPD_LIC_PARAMS)=> command(bluetoothCommands.UPD_LIC(params))

const commands = {
  MEAS_CTRL_ON,
  MEAS_CTRL_OFF,
  MEAS_RES,
  GET_INFO,
  GET_STAT,
  GET_FILE,
  INIT_LIC,
  UPD_LIC,
}

export {
  commands as default,
  MEAS_CTRL_ON,
  MEAS_CTRL_OFF,
  MEAS_RES,
  GET_INFO,
  GET_STAT,
  GET_FILE,
  INIT_LIC,
  UPD_LIC,
  STATUS,
  FILE_TYPE,
  MAXIMUM_FILE_BLOCKS,
  EXPECTED_FILE_BLOCKS,
  MEAS_DURATION,
}
